export function getConfig(mode) {
    return {
        indexes: {
            content: mode === 'staging' ? 'staging_content' : 'prod_content',
            brands: mode === 'staging' ? 'staging_brands' : 'prod_brands',
            builds: mode === 'staging' ? 'staging_builds' : 'prod_builds',
            categories: mode === 'staging' ? 'staging_categories' : 'prod_categories',
            dealers: mode === 'staging' ? 'staging_dealers' : 'prod_dealers',
            products: mode === 'staging' ? 'staging_products' : 'prod_products',
            vehicles: mode === 'staging' ? 'staging_vehicles' : 'prod_vehicles',
            redirects: mode === 'staging' ? 'staging_redirects' : 'prod_redirects',
            salesReps: mode === 'staging' ? 'staging_sales_reps' : 'prod_sales_reps',
        },
    }
}
